import { useEffect } from "react";

function OperationButton({ operation, onClick }) {
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === String(operation)) {
        onClick(operation);
      }
    };
    document.addEventListener("keydown", handleKeyPress);
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [operation, onClick]);

  return (
    <button 
    className="btn btn-block btn-dark"
    onClick={() => onClick(operation)}>
      {operation}
    </button>
  );
}

export default OperationButton;
